import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=09948ade&scoped=true&"
import script from "./MessageTemplates.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09948ade",
  null
  
)

export default component.exports